import { combineReducers } from '@reduxjs/toolkit'

import { REDUCER_INDEX } from '../../constants'
import * as profile from './profile'

export * as profile from './profile'

export const actions = {
  ...profile.actions,
}

export const epics = [...profile.epics]

export const reducer = combineReducers({
  profile: profile.reducer,
})

interface State {
  profile: ReturnType<typeof profile.reducer>
}

export const selectors = {
  profile: Object.assign(
    ({ [REDUCER_INDEX]: state }: { [REDUCER_INDEX]: { currentUser: State } }) => state.currentUser.profile,
    profile.selectors,
  ),
}
